/* cSpell:words Menlo, Segoe, Consolas */
import { styledComponentsTheme as uiKitTheme } from '#app/theme/styledComponentsTheme.js';
import { textStyles } from './textStyles.js';
import { themeV2 } from './themeV2.js';

export const breakpoints = uiKitTheme.breakpoints;

const zIndices = {
  bottomDrawer: {
    backdrop: 1_002,
    dialog: 1_003,
  },
  chat: {
    dialog: 500,
  },
  menu: 200,
  modal: {
    backdrop: 1_000,
    dialog: 1_001,
  },
  navbar: 500,
  navDrawer: {
    backdrop: 499,
    dialog: 1_001,
  },
  onboarding: 50,
  toaster: 9_999,
  toolbar: 100,
  tooltip: 300,
};

export const theme = {
  ...uiKitTheme,
  boxShadow: {
    basic10: '0px 0px 80px rgba(228, 232, 247, 0.4)',
    basic20: '0px 0px 24px rgba(228, 232, 247, 0.8)',
    blue20: '0px -2px 40px rgba(146, 200, 220, 0.32)',
    // Cards
    heavy: '0px 0px 80px rgba(228, 232, 247, 0.4);',
    // Pills/Tags/Menus
    light: '0px 0px 24px rgba(228, 232, 247, 0.8);',
    onboardingPopup: '0px -2px 40px rgba(146, 200, 220, 0.32);',
    pageActions: '0px 0px 24px rgba(169, 175, 200, 0.8);',
    toast: ' 0px 4px 14px rgba(0, 0, 0, 0.13);',
  },
  // TODO: Remove old `textStyles` and use from UI Kit.
  textStyles,
  zIndices,
  ...themeV2,
} as const;
